/* PLOP_INJECT_IMPORT */
import GallerySlice from './GallerySlice';
import AccessoriesNavigation from './AccessoriesNavigation'
import ArticleHeader from './ArticleHeader'
import ArtisansNavigation from './ArtisansNavigation'
import Cart from './Cart'
import CartLine from './CartLine'
import CartSummary from './CartSummary'
import ClothingNavigation from './ClothingNavigation'
import CollectionsNavigation from './CollectionsNavigation'
import ConsultationForm from './ConsultationForm'
import ContactNavigation from './ContactNavigation'
import CustomAndBespokeNavigation from './CustomAndBespokeNavigation'
import CustomerAddresses from './CustomerAddresses'
import CustomerOrder from './CustomerOrder'
import CustomerOrderLineItem from './CustomerOrderLineItem'
import CustomerOrders from './CustomerOrders'
import CustomerProfile from './CustomerProfile'
import EnquiryForm from './EnquiryForm'
import Hamburger from './Hamburger'
import ImageAndTextSlice from './ImageAndTextSlice'
import ImageSlice from './ImageSlice'
import ImagesSlice from './ImagesSlice'
import JournalNavigation from './JournalNavigation'
import Label from './Label'
import LoadingIndicator from './LoadingIndicator'
import LocationCard from './LocationCard'
import NewArrivalsNavigation from './NewArrivalsNavigation'
import PrismicPageHead from './PrismicPageHead'
import ProductDescription from './ProductDescription'
import ProductHistory from './ProductHistory'
import RadioInputs from './RadioInputs'
import SearchModal from './SearchModal'
import SearchResults from './SearchResults'
import SmallScreenModal from './SmallScreenModal'
import SpecialCollectionCard from './SpecialCollectionCard'
import TextInput from './TextInput'
import UpcomingTrunkShow from './UpcomingTrunkShow'

export {
  /* PLOP_INJECT_EXPORT */
	GallerySlice,
  LoadingIndicator,
  AccessoriesNavigation,
  ArticleHeader,
  ArtisansNavigation,
  Cart,
  CartLine,
  CartSummary,
  ClothingNavigation,
  CollectionsNavigation,
  ConsultationForm,
  ContactNavigation,
  CustomAndBespokeNavigation,
  CustomerAddresses,
  CustomerOrder,
  CustomerOrderLineItem,
  CustomerOrders,
  CustomerProfile,
  EnquiryForm,
  Hamburger,
  ImageAndTextSlice,
  ImageSlice,
  ImagesSlice,
  JournalNavigation,
  Label,
  LocationCard,
  NewArrivalsNavigation,
  PrismicPageHead,
  ProductDescription,
  ProductHistory,
  RadioInputs,
  SearchModal,
  SearchResults,
  SmallScreenModal,
  SpecialCollectionCard,
  TextInput,
  UpcomingTrunkShow,
}
